export default __webpack_public_path__ + "static/media/DEC ZURY PASSION-01.4c42a096.jpg";